import React from 'react';
import Hero from './Hero';
import Mission from './Mission';
import Categories from './Categories';
import FeaturedPublications from './FeaturedPublications';
import PricingTeaser from './PricingTeaser';
import NewsSection from './NewsSection';
import Newsletter from './Newsletter';

const Home = () => {
  return (
    <>
      <Hero />
      <Mission />
      <Categories />
      <FeaturedPublications />
      <PricingTeaser />
      <NewsSection />
      <Newsletter />
    </>
  );
};

export default Home;